(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2679],{

/***/ 25794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts",
      function () {
        return __webpack_require__(52872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _blocks_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23786);
/* harmony import */ var _blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var BlockLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-loader"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-loader__spinner"])
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockLoader);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 76193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);






var Pagination = function(param) {
    var _current = param.current, current = _current === void 0 ? 1 : _current, _siblings = param.siblings, siblings = _siblings === void 0 ? 1 : _siblings, _total = param.total, total = _total === void 0 ? 1 : _total, onPageChange = param.onPageChange;
    var setPage = function(value) {
        if (value < 1 || value > total || value === current) {
            return;
        }
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        } catch (e) {
            window.scrollTo(0, 0);
        }
        if (onPageChange) {
            onPageChange(value);
        }
    };
    var getPages = function() {
        var pages = [];
        var min = Math.max(1, current - siblings - Math.max(0, siblings - total + current));
        var max = Math.min(total, min + siblings * 2);
        for(var i = min; i <= max; i += 1){
            pages.push(i);
        }
        return pages;
    };
    var firstLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current <= 1));
    var lastLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current >= total));
    var pages = getPages().map(function(page, index) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-active"]), page === current));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]),
                onClick: function() {
                    return setPage(page);
                },
                children: [
                    page,
                    page === current && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]),
                        children: current
                    })
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: firstLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Previous",
                    onClick: function() {
                        return setPage(current - 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedLeft8x13Svg */ .lb, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--left"])),
                        "aria-hidden": "true"
                    })
                })
            }),
            pages,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: lastLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Next",
                    onClick: function() {
                        return setPage(current + 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight8x13Svg */ .pn, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--right"])),
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 52872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ posts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/posts/posts.module.scss
var posts_module = __webpack_require__(30406);
var posts_module_default = /*#__PURE__*/__webpack_require__.n(posts_module);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(91257);
// EXTERNAL MODULE: ./components/blocks/BlockLoader.tsx
var BlockLoader = __webpack_require__(18095);
// EXTERNAL MODULE: ./components/posts/PostCard.tsx
var PostCard = __webpack_require__(73519);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
// EXTERNAL MODULE: ./components/shared/Pagination.tsx
var Pagination = __webpack_require__(76193);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/posts/PostPage.tsx



















var buildQuery = function(options) {
    var params = {
        page: 0
    };
    if (options.page !== 1) {
        params.page = options.page;
    }
    return queryString.stringify(params, {
        encode: false
    });
};
var PostPage = function(props) {
    var _posts = props.posts, page = _posts.current_page, dbName = props.dbName, domain = props.domain, postCategories = props.postCategories, postTags = props.postTags, breadcrumb = props.breadcrumb, translationsData = props.translationsData, selectedLocale = props.selectedLocale, posts = (0,_object_without_properties/* default */.Z)(props.posts, [
        "current_page"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("all"), selectedCatSlug = ref[0], setSelectedCatSlug = ref[1];
    var ref1 = (0,react.useState)([]), selectedTags = ref1[0], setSelectedTags = ref1[1];
    var ref2 = (0,react.useState)(false), openDropDown = ref2[0], setOpenDropDown = ref2[1];
    var ref3 = (0,react.useState)(posts.total), total = ref3[0], _ = ref3[1];
    var schema = (0,schemaorg/* schemaPost */.ro)(dbName, router.asPath, posts.data);
    var prevLocaleCodeRef = (0,react.useRef)();
    var prevPageRef = (0,react.useRef)();
    var catSelectRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        prevPageRef.current = page;
        prevLocaleCodeRef.current = selectedLocale;
        var onClose = function(e) {
            if (catSelectRef && catSelectRef.current && !catSelectRef.current.contains(e.target)) {
                setOpenDropDown(false);
            }
        };
        document.addEventListener("mousedown", onClose);
        return function() {
            return document.removeEventListener("mousedown", onClose);
        };
    }, []);
    (0,react.useEffect)(function() {
        var query = router.query;
        var tags = query.tags, category = query.category;
        if (tags) {
            setSelectedTags(tags.split(",").map(function(el) {
                return +el;
            }));
        } else setSelectedTags([]);
        if (category) {
            setSelectedCatSlug(category);
        } else setSelectedCatSlug("all");
    }, [
        router.asPath
    ]);
    var handlePageChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            var updatedQuery;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!page || page === 1)) return [
                            3,
                            2
                        ];
                        updatedQuery = router === null || router === void 0 ? void 0 : router.query;
                        delete updatedQuery.page;
                        return [
                            4,
                            router.push({
                                query: updatedQuery
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.push({
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    page: page
                                })
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePageChange(page) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!posts.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLoader/* default */.Z, {});
    }
    var handleClickTags = function(tag_id) {
        var newState = (0,_to_consumable_array/* default */.Z)(selectedTags);
        if (selectedTags.includes(tag_id)) {
            newState = (0,_to_consumable_array/* default */.Z)(selectedTags.filter(function(el) {
                return el !== tag_id;
            }));
        } else {
            newState.push(tag_id);
        }
        var queryStr = newState.join();
        router.push({
            query: query_string.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                tags: queryStr
            }), {
                encode: false
            })
        });
        setSelectedTags((0,_to_consumable_array/* default */.Z)(newState));
    };
    var handleClickCategories = function(cat_slug) {
        setSelectedCatSlug(cat_slug);
        setOpenDropDown(false);
    };
    var catSelectForMobile = function() {
        var selectedCategory = postCategories.find(function(el) {
            return el.slug === selectedCatSlug;
        });
        var selectedOption = {
            true: {
                name: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name,
                slug: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.slug,
                class: (posts_module_default()).selected
            },
            false: {
                name: translationsData.PostCategoriesAll,
                slug: "all",
                class: ""
            }
        };
        var cat_drop_down = {
            true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (posts_module_default()).cat_drop_down,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((posts_module_default()).cat_option, " ").concat(selectedOption["".concat((selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.slug) === undefined)].class),
                        onClick: function() {
                            return handleClickCategories("all");
                        },
                        children: translationsData.PostCategoriesAll
                    }),
                    postCategories.map(function(cat) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((posts_module_default()).cat_option, " ").concat(selectedOption["".concat((selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.slug) === cat.slug)].class),
                            onClick: function() {
                                return handleClickCategories(cat.slug);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/posts/".concat(cat.slug),
                                style: {
                                    display: "block"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/posts/".concat(cat.slug),
                                    children: cat.name
                                })
                            })
                        }, cat.id);
                    })
                ]
            }),
            false: null
        };
        var dropDownArrowClasses = {
            true: "".concat((posts_module_default()).drop_down_arrow, " ").concat((posts_module_default()).opened),
            false: (posts_module_default()).drop_down_arrow
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((posts_module_default()).post_cat_filter_body, " ").concat((posts_module_default()).mobile),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (posts_module_default()).cat_select,
                ref: catSelectRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (posts_module_default()).cat_button,
                        onClick: function() {
                            return setOpenDropDown(function(prevState) {
                                return !prevState;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    selectedOption["".concat(!!selectedCategory)].name,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CustomSelectArrow */.xl, {
                                className: dropDownArrowClasses["".concat(openDropDown)]
                            })
                        ]
                    }),
                    cat_drop_down["".concat(openDropDown)]
                ]
            })
        });
    };
    var activeCategoryClasses = {
        true: "".concat((posts_module_default()).post_filters_row, " ").concat((posts_module_default()).active),
        false: "".concat((posts_module_default()).post_filters_row)
    };
    var postsList = posts.data.map(function(post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (posts_module_default()).post_list_item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                post: post,
                category: post.default_category,
                // dbName={dbName}
                // domain={domain}
                translationsData: translationsData,
                date_checked: true,
                read_more_checked: true
            })
        }, post.id);
    });
    var postFilters = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (posts_module_default()).post_filters,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((posts_module_default()).post_category_filters, " ").concat((posts_module_default()).post_filter),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (posts_module_default()).post_filter_title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* PostCatsFilterIcon */.uE, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: translationsData.PostCategories
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((posts_module_default()).post_cat_filter_body, " ").concat((posts_module_default()).desktop),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: activeCategoryClasses["".concat(selectedCatSlug === "all")],
                                onClick: function() {
                                    return handleClickCategories("all");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationsData.PostCategoriesAll
                                })
                            }),
                            postCategories.map(function(cat) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: activeCategoryClasses["".concat(selectedCatSlug === cat.slug)],
                                    onClick: function() {
                                        return handleClickCategories(cat.slug);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/posts/".concat(cat.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/posts/".concat(cat.slug),
                                            children: cat.name
                                        })
                                    })
                                }, cat.id);
                            })
                        ]
                    }),
                    catSelectForMobile()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((posts_module_default()).post_tags_filters, " ").concat((posts_module_default()).post_filter),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (posts_module_default()).post_filter_title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* PostTagsFilterIcon */.CJ, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: translationsData.Tags
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (posts_module_default()).post_tag_filter_body,
                        children: postTags.map(function(tag) {
                            var tagClasses = {
                                true: "".concat((posts_module_default()).post_filters_tag, " ").concat((posts_module_default()).active),
                                false: "".concat((posts_module_default()).post_filters_tag)
                            };
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: tagClasses["".concat(selectedTags.includes(tag.id))],
                                onClick: function() {
                                    return handleClickTags(tag.id);
                                },
                                children: tag.name
                            }, tag.id);
                        })
                    })
                ]
            })
        ]
    });
    var filterIsHidden = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (posts_module_default()).post_body,
            children: [
                postFilters,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (posts_module_default()).posts_list,
                    children: postsList
                })
            ]
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (posts_module_default()).posts_list,
            children: postsList
        })
    };
    var viewPosts = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block",
            children: [
                filterIsHidden["".concat(postCategories.length > 1)],
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (posts_module_default()).posts_pagination,
                    style: {
                        margin: "47px 0"
                    },
                    children: (posts === null || posts === void 0 ? void 0 : posts.total) <= 1 ? // {postsList && postsList.length < 20 ? (
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        current: +page,
                        siblings: 2,
                        total: total,
                        onPageChange: handlePageChange
                    })
                })
            ]
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (posts_module_default())["products-view__empty"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (posts_module_default())["products-view__empty-title"],
                    children: translationsData.NothingFound
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (posts_module_default())["products-view__empty-subtitle"],
                    children: translationsData.TryResetFilters
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "btn btn-orange btn-sm",
                    onClick: function() {
                        router.push(router.pathname);
                    },
                    children: translationsData.Reset
                })
            ]
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                header: "Latest News",
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (posts_module_default()).post_page_title,
                            children: translationsData.Posts
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: viewPosts["".concat(!!postsList.length)]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var posts_PostPage = (PostPage);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 32 modules
var MainLayout = __webpack_require__(75947);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/posts/index.tsx









var PagePosts = function(props) {
    var selectedLocale = props.selectedLocale, domain = props.domain, _post_metas = props.post_metas, _meta_title = _post_metas.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = _post_metas.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = _post_metas.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, _share_pic = _post_metas.share_pic, share_pic = _share_pic === void 0 ? "" : _share_pic, dbName = props.dbName, posts = props.posts, postCategories = props.postCategories, postTags = props.postTags, breadcrumb = props.breadcrumb, translationsData = props.translationsData, siteName = props.siteName, defaultLangCode = props.defaultLangCode, locales = props.locales;
    var router = (0,next_router.useRouter)();
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    var meta_image = (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(share_pic));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:image",
                            content: meta_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: meta_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:site_name",
                            content: siteName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(posts_PostPage, {
                    dbName: dbName,
                    domain: domain,
                    posts: posts,
                    postCategories: postCategories,
                    postTags: postTags,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData,
                    selectedLocale: selectedLocale
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var posts = (PagePosts);


/***/ }),

/***/ 23786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block-loader":"blocks_block-loader__kxJ59","block-loader__spinner":"blocks_block-loader__spinner__zfmWE","preloader-animation":"blocks_preloader-animation__7qffr","block-products__featured":"blocks_block-products__featured__EGd2M","product-card-parent":"blocks_product-card-parent__9IJfC","block-products__list":"blocks_block-products__list__yXaFe","block-products__body":"blocks_block-products__body__BL7Wg","block-products-carousel__column":"blocks_block-products-carousel__column__fOCMc","block":"blocks_block__o6zIm","block-products-carousel":"blocks_block-products-carousel__kVyQR","slick-track":"blocks_slick-track__GydZI","slick-list":"blocks_slick-list__RDAcl","slick-slide":"blocks_slick-slide__Hr2SD","correct-slick-active":"blocks_correct-slick-active__a2_Zw","block-products-carousel__preloader":"blocks_block-products-carousel__preloader__QkzPY","block-products-carousel--loading":"blocks_block-products-carousel--loading__dAZ1U","block-products-carousel--has-items":"blocks_block-products-carousel--has-items__Sytel","block-products-carousel__slider":"blocks_block-products-carousel__slider__3UJ_7","block-products-carousel__cell":"blocks_block-products-carousel__cell__5qHDN","home-product-container":"blocks_home-product-container__l9O4Y"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,3997,4531,9774,2888,179], function() { return __webpack_exec__(25794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);